/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lonely-if */
/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Menu } from 'primereact/menu';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useMsal } from '@azure/msal-react';

import './Header.scss';

import { getInitials, handleError } from '../../utils';
import navigationGuard from '../../utils/navigationGuard';
import { useAuth } from '../../hooks/useAuth';
import { useRoleContext } from '../../hooks/useRoleContext';
import NotificationPopover from '../../components/NotificationPopover/NotificationPopover';
import useAxios from '../../hooks/useAxios';

import LogoImg from '../../assets/icons/logo.svg';
import BellIcon from '../../assets/icons/bell-icon.svg';
import DownArrowIcon from '../../assets/icons/down-arrow.svg';
import SearchIcon from '../../assets/icons/magnify.svg';
import CloseIcon from '../../assets/icons/input-close.svg';

const Header = () => {
  const toast = useRef<any>(null);
  const toastBottom = useRef<any>(null);
  const op = useRef<OverlayPanel>(null);
  const menuLeft = useRef<any>(null);
  const { role } = useRoleContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const { instance } = useMsal();
  const [nameInitial, setNameInitial] = useState<any>(null);
  const [userName, setuserName] = useState<any>(null);
  const [searchText, setSearchText] = useState('');
  const [notifications, setNotifications] = useState<any>(null);
  const [unreadCount, setUnreadCount] = useState<number>(0);

  const socketBaseUrl = process.env.SOCKET_BASE_URL;
  const { get, post, apiLoading } = useAxios();

  const socketRef = useRef<WebSocket | null>(null);

  const socketUrl = `wss://${socketBaseUrl}/notification-manager/ws/get_unread_notification_count`;

  const navigate = useNavigate();
  const { logout } = useAuth();

  const updateNotificationsAsRead = (targetId: string | 'all'): any => {
    const updateGroup = (group: any) => {
      const updated = group.notifications.map((n: any) => {
        if (targetId === 'all' || n.id === targetId) {
          return { ...n, is_read: true };
        }
        return n;
      });

      return { ...group, notifications: updated };
    };

    const updatedData = {
      all_notifications: updateGroup(notifications.all_notifications),
      mentions: updateGroup(notifications.mentions),
      annotations: updateGroup(notifications.annotations),
    };

    setNotifications(updatedData);
  };

  const markNotificationAsRead = async (id: any) => {
    let apiPath = '';
    let postData: any;

    if (id === 'all') {
      apiPath = 'notification-manager/mark_all_notifications_as_read';
    } else {
      apiPath = 'notification-manager/mark_notification_as_read';
      postData = id;
    }

    await post(apiPath, postData).then((response: any) => {
      const { status } = response;

      if ([200, 201].includes(status)) {
        const respData = response.data.messages;
        if (respData) {
          updateNotificationsAsRead(id);
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'Notification marked as read!', life: 3000 });
        }
      }
    })
      .catch((error: any) => {
        if ([401, 404, 500].includes(error?.request?.status)) {
          handleError(error, toastBottom);
        }
      });
  };

  const markAsRead = (id: any, data?: any) => {
    if (id) {
      markNotificationAsRead(id);

      if (id !== 'all') {
        op.current?.hide();

        if (data.category === 'due_date' && data.event_name === 'Upcoming Due Date Reminder - 5 days') {
          navigate('/workflows/list?type=due_5');
        } else if (data.category === 'due_date' && data.event_name === 'Upcoming Due Date Reminder - 1 day') {
          navigate('/workflows/list?type=due_1');
        } else if (data.category === 'due_date' && data.event_name === 'Overdue') {
          if (['admin', 'marcom', 'brand_owner', 'agency'].includes(role)) {
            navigate(`/workflow/edit/${data.workflow_id}`);
          } else if (role === 'reviewer' && data?.file_attachment_id) {
            navigate(`/annotation-studio/${data?.file_attachment_id}`);
          } else if (role === 'reviewer') {
            navigate('/workflows/list?type=overdue');
          }
          // navigate('/workflows/list?type=overdue');
        } else if (data.category === 'assets' && data.event_name === 'assets') {
          navigate(`/assets-library?type=expired_assets&id=${data?.asset_id}`);
        } else if (data.category === 'workflow' && ['Material Upload In Progress', 'Material Upload Completed'].includes(data.event_name) && data.workflow_status === 'approved') {
          navigate(`/workflow/edit/${data.workflow_id}?step=4`, { state: {} });
        } else if (data.category === 'workflow' && ['Material Upload In Progress', 'Material Upload Completed'].includes(data.event_name) && data.workflow_status !== 'approved') {
          navigate(`/workflow/edit/${data.workflow_id}?step=3`, { state: {} });
        } else if (data.category === 'mentions' && data.file_status !== 'ai_annotation') {
          let url = `/annotation-studio/${data.workflow_id}/${data.file_id}?annotation_id=${data.annotation_id}&at_mentions=true`;
          if (data.comment_id) {
            url += `&comment_id=${data.comment_id}`;
          }
          navigate(url, { state: {} });
        } else if (data.category === 'mentions' && data.file_status === 'ai_annotation') {
          let url = `/annotation-studio/${data.workflow_id}/${data.file_id}?annotation_id=${data.annotation_id}&ai_annotation=true&ai_rule_collection_id=${data.ai_rule_collection_id}&at_mentions=true`;
          if (data.comment_id) {
            url += `&comment_id=${data.comment_id}`;
          }
          navigate(url, { state: {} });
        } else if (data.category === 'annotations') {
          let url = `/annotation-studio/${data.workflow_id}/${data.file_id}?annotation_id=${data.annotation_id}`;

          if (data.comment_id) {
            url += `&comment_id=${data.comment_id}`;
          }

          navigate(url, { state: {} });
        } else if (data.category === 'verdict' && data.event_name === 'Auto Render Needs Meeting') {
          let url = `/annotation-studio/${data.workflow_id}/${data.file_attachment_id}`;

          navigate(url, { state: {} });
        } else {
          if (data.workflow_id && data.file_id) {
            navigate(`/annotation-studio/${data.workflow_id}/${data.file_id}`, { state: {} });
          } else if (data.workflow_id && !data.file_id) {
            navigate(`/workflow/edit/${data.workflow_id}`, { state: {} });
          }
        }
      }
    }
  };

  const handleLogout = () => {
    const activeAccount = instance.getActiveAccount();
    if (activeAccount) {
      logout();
      instance.logoutRedirect();
    } else {
      logout();
    }
  };

  const userMenuItems = [
    {
      label: 'Profile',
      command: () => {
        navigationGuard.navigate(() => {
          localStorage.removeItem('lastWorkflowClickedRow');
          localStorage.removeItem('lastclickFrom');
          navigate('/profile');
        });
      }
    },
    {
      label: 'Settings',
      command: () => {
        navigationGuard.navigate(() => {
          localStorage.removeItem('lastWorkflowClickedRow');
          localStorage.removeItem('lastclickFrom');
          navigate('/settings');
        });
      }
    },
    {
      label: 'Configuration',
      command: () => {
        navigationGuard.navigate(() => {
          localStorage.removeItem('lastWorkflowClickedRow');
          localStorage.removeItem('lastclickFrom');
          navigate('/configuration');
        });
      },
      visible: ['admin', 'marcom'].includes(role)
    },
    {
      label: 'Logout',
      command: () => {
        navigationGuard.navigate(() => {
          localStorage.removeItem('sessionExpired');
          handleLogout();
        });
      }
    }
  ];

  const onSearchSubmit = (e: any) => {
    e.preventDefault();
    if (searchText !== '') {
      navigate(`/search-result?text=${searchText}`);
    }
  };

  const closePopup = () => {
    op.current?.hide();
  };

  useEffect(() => {
    let socket: WebSocket;

    const connect = () => {
      socket = new WebSocket(socketUrl);
      socketRef.current = socket;

      socket.onopen = () => {
        // console.log('Connected');
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          const newCount = data?.messages?.[0]?.unread_notification_count;

          if (typeof newCount === 'number') {
            setUnreadCount((prev) => {
              if (prev !== newCount) {
                return newCount;
              }
              return prev;
            });
          }
        } catch (e) {
          console.error('Invalid WS message', e);
        }
      };

      socket.onclose = () => {
        setTimeout(connect, 5000);
      };
    };

    connect();

    return () => {
      if (socket) {
        socket.onclose = null;
        socket.close();
      }
    };
  }, [socketUrl]);

  const getUserBatch = (ids: any) => {
    const postData = {
      id_list: ids
    };

    try {
      const res = post('user-manager/batch_get_user_details', postData).then((response: any) => {
        const { status } = response;

        if ([200, 201].includes(status)) {
          if (response.data.messages && response.data.messages.length > 0) {
            return response.data.messages;
          }
        }
      });

      return res;
    } catch (error: any) {
      if ([401, 404, 500, 422].includes(error?.request?.status)) {
        handleError(error, toastBottom);
      }
    }
  };

  const getHeaderNotifications = async (filterType: any = '', notificationType = 'all') => {
    let apiPath = `notification-manager/get_all_notifications?category=${notificationType}&results_per_page=5&page_number=1`;
    if (filterType === 'onlyunread') {
      apiPath += '&unread_only=true';
    }

    await get(apiPath).then((response: any) => {
      const { status } = response;

      if ([200, 201].includes(status)) {
        const respData = response.data.messages;

        const allUserIds = [
          ...new Set([
            ...respData.all_notifications.notifications.map((n: any) => n.action_initiator),
            ...respData.mentions.notifications.map((n: any) => n.action_initiator),
            ...respData.annotations.notifications.map((n: any) => n.action_initiator),
          ].filter((id) => id !== null && id !== undefined))
        ];

        if (allUserIds.length > 0) {
          getUserBatch(allUserIds)?.then((res: any) => {
            const userMap = new Map(res.map((u: any) => [u.id, u]));

            const enrichWithUsers = (arr: any[]) => arr.map((item: any) => {
              const userData: any = userMap.get(item.action_initiator);
              return {
                ...item,
                fullName: userData ? `${userData.first_name} ${userData.last_name}` : item.action_initiator,
              };
            });

            const enriched = {
              all_notifications: {
                ...respData.all_notifications,
                notifications: enrichWithUsers(respData.all_notifications.notifications),
              },
              mentions: {
                ...respData.mentions,
                notifications: enrichWithUsers(respData.mentions.notifications),
              },
              annotations: {
                ...respData.annotations,
                notifications: enrichWithUsers(respData.annotations.notifications),
              },
            };

            setNotifications(enriched);
          });
        } else {
          setNotifications({
            all_notifications: { ...respData.all_notifications, notifications: [] },
            mentions: { ...respData.mentions, notifications: [] },
            annotations: { ...respData.annotations, notifications: [] },
          });
        }
      }
    })
      .catch((error: any) => {
        if ([401, 404, 500].includes(error?.request?.status)) {
          handleError(error, toastBottom);
        }
      });
  };

  const getOnlyUnread = (data: boolean) => {
    if (data) {
      getHeaderNotifications('onlyunread');
    } else {
      getHeaderNotifications();
    }
  };

  const onTabChange = (tabType?: string) => {
    getHeaderNotifications('', tabType);
  };

  useEffect(() => {
    if (searchParams.get('text')) {
      setSearchText(searchParams.get('text'));
    } else {
      setSearchText('');
    }
  }, [searchParams]);

  useEffect(() => {
    const uname = localStorage.getItem('username');
    setuserName(uname);
    setNameInitial(getInitials(uname));
  }, []);

  return (
    <div className="header-container" style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '10.25px' }}>
      <div className="flex flex-shrink-0 sidebar-logo" onClick={() => navigate('/home')}>
        <img src={LogoImg} style={{ height: '48px', width: '48px' }} alt="Logo" />
      </div>
      <div className="header-content">
        <div className="header-nav">
          <div className="header-nav-items">
            <div className="header-nav-item">
              <form onSubmit={(e) => onSearchSubmit(e)} method="get" className="relative">
                <IconField iconPosition="left" className="header-search-input">
                  <InputIcon>
                    <img src={SearchIcon} alt="search" />
                  </InputIcon>
                  <InputText value={searchText} placeholder="Search" style={{ width: '275px', paddingTop: '7px', paddingBottom: '7px', paddingRight: '30px', fontSize: '12px', borderRadius: '7px', border: '1px solid #5C5C5C' }} onChange={(e) => setSearchText(e.target.value)} />
                </IconField>
                {searchText && searchText !== '' && (
                  <img
                    src={CloseIcon}
                    alt="remove"
                    style={{ position: 'absolute', top: '11px', right: '10px', cursor: 'pointer' }}
                    onClick={() => setSearchText('')}
                  />
                )}
              </form>
            </div>
            <div className="header-nav-item">
              {unreadCount && unreadCount > 0
                ? (
                  <Avatar
                    className="p-overlay-badge notification-avatar"
                    image={BellIcon}
                    shape="circle"
                    onClick={(e) => {
                      getHeaderNotifications();
                      op.current?.toggle(e);
                    }}
                  >
                    <Badge value={unreadCount} severity="danger" />
                  </Avatar>
                ) : (
                  <Avatar
                    className="notification-avatar"
                    image={BellIcon}
                    shape="circle"
                    onClick={(e) => {
                      getHeaderNotifications();
                      op.current?.toggle(e);
                    }}
                  />
                )}

              <OverlayPanel className="notification-popover-container" ref={op} style={{ width: '500px' }} dismissable>
                <NotificationPopover markAsRead={markAsRead} notifications={notifications} closePopup={closePopup} getOnlyUnread={getOnlyUnread} loading={apiLoading} onTabChange={(type: any) => onTabChange(type)} />
              </OverlayPanel>
            </div>
            <div className="header-nav-item">
              <div className="flex align-items-center" onClick={(event) => menuLeft?.current?.toggle(event)}>
                <Avatar label={nameInitial} className="user-avatar mr-3" shape="circle" onClick={(event) => menuLeft?.current?.toggle(event)} />
                <div className="mr-4">
                  <div className="header-username">{userName}</div>
                  <div className="header-role capitalize">{(role === 'brand_owner') ? 'Project Owner' : role?.replaceAll(/_/g, ' ')}</div>
                </div>
                <img src={DownArrowIcon} alt="down" />
              </div>
              <Menu
                className="header-menu"
                model={userMenuItems}
                ref={menuLeft}
                pt={{
                  root: { style: { borderRadius: '12px', width: '207px', padding: '0px', overflow: 'hidden' } },
                  menuitem: { style: { height: '45px' } },
                  // action: { className: 'custom-menuitem-link' }
                }}
                popup
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
